import { RuleResult } from 'types/DeclarationP5'

const C0191Validator = {
  validatePlaceOfUnloadingRequirement: (security: string): RuleResult => {
    if (security === '0') return 'NOT_ALLOWED'
    if (['1', '3'].includes(security)) return 'REQUIRED'

    return 'OPTIONAL'
  },
}

export default C0191Validator
